var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hb-basic-page',{attrs:{"loading":true}})}
var staticRenderFns = []

export { render, staticRenderFns }